import {
	handleActions
} from 'redux-actions';
import Immutable from 'immutable';

const GearModelListState = Immutable.fromJS({
	gearModelList: [],
	activePage: 1,
	itemPerPage: 10,
	totalPage: 1
});

const gearModelListReducer = handleActions({
	FIND_GEARMODEL_LIST: (state, { payload }) => {
		return state.merge({
			gearModelList: payload.data.dataTableData,
			activePage: payload.data.activePage,
			totalPage: payload.data.totalPage,
			itemPerPage: payload.data.itemPerPage,
		})
	},
	CHANGE_GEARMODEL_ACTIVE_PAGE: (state, { payload }) => {
		return state.merge({
			activePage: payload.activePage,
			itemPerPage: payload.itemPerPage
		})
	}
}, GearModelListState);

export default gearModelListReducer;


// WEBPACK FOOTER //
// ./src/reducers/gearModelListReducer.js